import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/States";

export default function RequireRole({ kinds, redirect }) {
  const { principal, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loading label="Verificando tu sesion..." testId="auth-loading" />;
  if (!principal) return <Navigate to={redirect} replace state={{ from: location.pathname }} />;
  if (!kinds.includes(principal.kind)) {
    const home = principal.kind === "student" ? "/s" : principal.kind === "platform_admin" ? "/admin" : "/p";
    return <Navigate to={home} replace />;
  }
  return <Outlet />;
}
